export class ReplicationStatus {
  threadStarted: boolean;
  replicationEnabled: boolean;
}
